import { Injectable, OnDestroy } from '@angular/core';
import { Observable, timer, Subject } from 'rxjs';
import { share, switchMap, takeUntil } from 'rxjs/operators';
import { Message } from 'src/app/shared/models/message';
import { ConstantsService } from '../constant/constants.service';
import { environment } from 'src/environments/environment';
import { FacadeService } from '../facade.service';
import { GenericCrudService } from '../generic-crud.service';
@Injectable({
	providedIn: 'root'
})
export class MessageService implements OnDestroy {
	messageSubject: Observable<Message[]>;
	private stopReloding = new Subject<void>();
	environment = environment;
	constructor(
		private appConstants: ConstantsService,
		private facade: FacadeService,
		private genericCrudService: GenericCrudService
	) {}

	getAllMessageByIdSenderAndIdReceiverReload(
		idSender: number,
		idReceiver: number
	): Observable<Message[]> {
		this.messageSubject = timer(
			1,
			this.facade.dataStorageService.getRefreshNotificationRateInSeconds() *
				1000
		).pipe(
			switchMap(() => {
				return this.genericCrudService.genericGetAPIData(
					`${this.appConstants.messageUrl}/${idSender}/${idReceiver}`,
					'getAllMessageByIdSenderAndIdReceiver'
				);
			}),
			// retry(),
			share(),
			takeUntil(this.stopReloding)
		);
		return this.messageSubject;
	}

	addMessage(message: Message): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.messageUrl}`,
			`addMessage`,
			message
		);
	}

	ngOnDestroy() {
		this.stopReloding.next();
	}
}
